export const translation = {
  en: {
    CASHANALYZE_HEADER: 'Include Cash in the Analysis',
    CASHANALYZE_P1:
      'The regular analysis excludes the cash in your account balance (0% interest) because it assumes that the amount is temporary. Here you can include cash in the analysis: i) if it is an intended allocation, or ii) to see the impact of the so-called “cash drag”.',
    CASHANALYZE_P2:
      'Since cash has no market exposure, it will likely drag down returns over time relative to the benchmark, which has no cash.',
    CASHANALYZE_ANALYZE: 'Analyze',
    CASHANALYZE_ANALYZECAD: 'Analyze In CAD',
    CASHANALYZE_ANALYZEUSD: 'Analyze In USD',
    WARNING_NEGATIVEPORT:
      'Analysis will not be performed for net short portfolio(s).',
    WARNING_SHORTPOSITIONS:
      'Short positions will be excluded from the analysis.',
  },
  fr: {
    CASHANALYZE_HEADER:
      'Inclure l’argent liquide dans votre compte pour l’analyse du portefeuille',
    CASHANALYZE_P1:
      'Le bouton principal « Analyser » suppose que l’argent liquide dans votre compte (0 % d’intérêt) est temporaire et l’exclut de l’analyse. Ici, vous pouvez inclure l’argent liquide dans l’analyse et voir l’impact de ce qu’on appelle la « traînée de l’argent liquide » sur les scores de votre portefeuille.',
    CASHANALYZE_P2:
      'Étant donné que l’argent liquide n’a aucune exposition au marché, elle risque de réduire les rendements au fil du temps par rapport à l’indice de référence, qui n’a pas d’argent liquide.',
    CASHANALYZE_ANALYZE: 'Analyser',
    CASHANALYZE_ANALYZECAD: 'Analyser en CAD',
    CASHANALYZE_ANALYZEUSD: 'Analyser en USD',
    WARNING_NEGATIVEPORT:
      'L’analyse ne sera pas effectuée pour les portefeuilles net courts.',
    WARNING_SHORTPOSITIONS:
      'Les positions courtes seront exclues de l’analyse.',
  },
};
